import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageMeta } from '../lib/usePageMeta';
import { HomeNav } from '../components/landing/home/HomeNav';
import { HomeHero } from '../components/landing/home/HomeHero';
import { AgencyFilm } from '../components/landing/home/AgencyFilm';
import { VoiceOutcomes } from '../components/landing/home/VoiceOutcomes';
import { HomeWorkflow } from '../components/landing/home/HomeWorkflow';
import { HomeNiches } from '../components/landing/home/HomeNiches';
import { HomeIntegrations } from '../components/landing/home/HomeIntegrations';
import { HomePricing } from '../components/landing/home/HomePricing';
import { HomeFAQ } from '../components/landing/home/HomeFAQ';
import { HomeClosing } from '../components/landing/home/HomeClosing';
import { HomeFooter } from '../components/landing/home/HomeFooter';
import { IntegrationStrip } from '../components/landing/home/BrandIcon';
import { SharedMemory } from '../components/landing/home/SharedMemory';
import { PlaysSection } from '../components/landing/home/PlaysSection';
import '../components/landing/home/home.css';
import '../components/landing/home/home-readable.css';
import '../components/landing/home/home-rotation.css';
import '../components/landing/home/plan-cards.css';
import '../components/landing/home/agency.css';
import '../components/landing/home/apple-flow.css';

export default function LandingPage() {
  const { hash } = useLocation();
  const film = useRef(null);
  usePageMeta('Voxinity — AI Voice & Chat. Every Channel. One Memory.', 'Build AI agents your clients will love. Voice and chat that pick up where the last conversation left off, under your agency’s brand. Get started free.');
  useLayoutEffect(() => {
    document.documentElement.classList.add('homepage-viewport');
    return () => document.documentElement.classList.remove('homepage-viewport');
  }, []);
  useEffect(() => {
    // Preserve old inbound anchors without retaining the repeated old sections.
    const aliases = { voice: 'platform', features: 'platform', agency: 'platform', pipeline: 'how-it-works', onboarding: 'how-it-works', 'client-onboarding': 'how-it-works', compare: 'pricing' };
    const key = hash.slice(1);
    const target = document.getElementById(aliases[key] || key);
    if (target) target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    else window.scrollTo(0, 0);
  }, [hash]);
  return <div id="top" className="homepage agency-site" data-testid="landing-page">
    <a className="hm-skip-link" href="#home-main" data-testid="home-skip-link">Skip to content</a>
    <HomeNav />
    <main id="home-main" data-testid="home-main">
      <HomeHero onWatch={() => film.current?.watch()} />
      <IntegrationStrip />
      <PlaysSection />
      <VoiceOutcomes />
      <SharedMemory />
      <HomeIntegrations />
      <HomeWorkflow />
      <HomeNiches />
      <AgencyFilm ref={film} />
      <HomePricing />
      <HomeFAQ />
      <HomeClosing />
    </main>
    <HomeFooter />
  </div>;
}